/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderVideoEnum } from './orderVideoEnum';
import { OrderStatusEnum } from './orderStatusEnum';
import { OrderTypeEnum } from './orderTypeEnum';


export interface CreateOrderRequest { 
    orderId?: number | null;
    branchId?: number | null;
    realEstateAgentId?: number | null;
    priceFrom?: number | null;
    priceTo?: number | null;
    locality?: string | null;
    types?: Array<OrderTypeEnum> | null;
    statuses?: Array<OrderStatusEnum> | null;
    properties?: Array<number> | null;
    video?: Array<OrderVideoEnum> | null;
}

